export enum TypeEnum {
    Stock_Items = "Stock Items",
    End_Customer = "End Customer",
    Vendor = "Vendor"
}